export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/heatMapWorker.798b3590.worker.js");
}
